import React, {useState, useMemo, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Poker, Betting, Casino, TournamentCasino } from './Tabs';
import '../../../../assets/stylesheets/ClubSlide/MainClub.scss';
import RealTabSwitcher from '../../../Units/RealTabSwitcher';
import { setGameCategory } from '../../../../store/actionCreators/gameCategories';
import { getClubProducts, getCurrentClubId, getSelectedTab } from "../../../../store/selectors";
import configs from '../../../../config/config';

const ClubContent = () => {

    const dispatch = useDispatch();
    const [tabs, setTabs] = useState([]);
    const [selectedTab, selectTab] = useState('');
    const currentClubId = useSelector(getCurrentClubId);
    const prods =  useSelector(getClubProducts);
    const clubProducts = useMemo(() => !!currentClubId && prods[currentClubId] ? prods[currentClubId] : [], [prods, currentClubId]);
    const currentTab = useSelector(getSelectedTab);

    useEffect(() => {
        if( !!tabs && tabs.length && (!selectedTab || !tabs.includes(selectedTab) )) {
            selectTab(currentTab || tabs[0].name);
        }
    }, [tabs]);

    useEffect(() => {
        let arrTabs = [];
        configs.supportedTabs.forEach(prod => {
            if(clubProducts.includes(prod)) {
                arrTabs.push({
                    name: prod,
                    callback: () => changeTabName(prod)
                });
            }
        });
        setTabs(arrTabs);
    }, [clubProducts]);

    const changeTabName =  tabName => {
        selectTab(tabName);
        dispatch(setGameCategory(tabName));
    };

    return (
        <React.Fragment>
            <RealTabSwitcher tabs={tabs} onClick={selectTab} selected={selectedTab}/>
            {selectedTab === 'poker' && <Poker/>}
            {selectedTab === 'casino' && <Casino category='casino'/>}
            {selectedTab === 'liveCasino' && <Casino category='liveCasino'/>}
            {selectedTab === 'betting' && <Betting onClose={() => changeTabName('betting')} />}
            {selectedTab === 'casinoTournament' && <TournamentCasino onClose={() => changeTabName('betting')} />}
        </React.Fragment>
    );
};

export default ClubContent;
